var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoices" },
    [
      _c(
        "div",
        { staticClass: "main-wrapper" },
        [
          _c("layout-header"),
          _vm._v(" "),
          _c("layout-sidebar"),
          _vm._v(" "),
          _c("div", { staticClass: "page-wrapper" }, [
            _c("div", { staticClass: "content container-fluid" }, [
              _c("div", { staticClass: "page-header" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("h3", { staticClass: "page-title" }, [_vm._v("Brands")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "breadcrumb" }, [
                      _c(
                        "li",
                        { staticClass: "breadcrumb-item" },
                        [
                          _c("router-link", { attrs: { to: "/index" } }, [
                            _vm._v("Dashboard")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("li", { staticClass: "breadcrumb-item active" }, [
                        _vm._v("Brands")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto float-right ml-auto" }, [
                    _c(
                      "a",
                      {
                        ref: "formBc",
                        staticClass: "btn add-btn",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#add_form"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showBroadcast(true)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-tags" }),
                        _vm._v(" Add Brand\n              ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        ref: "formBcEdit",
                        staticClass: "btn add-btn",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#add_form"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showBroadcast(false)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-tags" }),
                        _vm._v(" Edit\n              ")
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row filter-row" }, [
                _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                  _c("div", { staticClass: "form-group form-focus" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.name,
                          expression: "serverParams.name"
                        }
                      ],
                      staticClass: "form-control floating",
                      attrs: { type: "text" },
                      domProps: { value: _vm.serverParams.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.serverParams,
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "focus-label" }, [
                      _vm._v("Name")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 col-md-6" }, [
                  _c("div", { staticClass: "form-group form-focus" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.description,
                          expression: "serverParams.description"
                        }
                      ],
                      staticClass: "form-control floating",
                      attrs: { type: "text" },
                      domProps: { value: _vm.serverParams.description },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.serverParams,
                            "description",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "focus-label" }, [
                      _vm._v("Description")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-success btn-block",
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.searchData($event)
                        }
                      }
                    },
                    [_vm._v("Search")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c(
                      "table",
                      { staticClass: "table table-striped custom-table mb-0" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm.loading
                              ? [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { attrs: { colspan: "4" } },
                                      [_c("Skeleton", { attrs: { count: 1 } })],
                                      1
                                    )
                                  ])
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.rows.length
                              ? _vm._l(_vm.rows, function(row, index) {
                                  return _c("tr", { key: index }, [
                                    _c(
                                      "td",
                                      { staticClass: "text-wrap" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to:
                                                "/statistik/brands?brand_id=" +
                                                row.id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(row.name) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-wrap" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(row.description))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-wrap" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            row.whatsapp_number != 0
                                              ? row.whatsapp_number
                                              : ""
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-wrap" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            row.whatsapp_group_number != 0
                                              ? row.whatsapp_group_number
                                              : ""
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown action-label"
                                        },
                                        [
                                          _vm._m(1, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.detailData(
                                                        row.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-pencil text-success"
                                                  }),
                                                  _vm._v(
                                                    " Edit\n                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteData(
                                                        row.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-trash text-danger"
                                                  }),
                                                  _vm._v(
                                                    " Delete\n                            "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                })
                              : _vm.rows.length < 1 && !_vm.loading
                              ? [_vm._m(2)]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12 col-md-6" }, [
                  _c("span", { staticClass: "footer__row-count__label" }, [
                    _vm._v("Displaying")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.perPage,
                          expression: "serverParams.perPage"
                        }
                      ],
                      staticClass: "select-to-paginasi",
                      staticStyle: { width: "100px" },
                      attrs: { autocomplete: "off", name: "perPageSelect" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.serverParams,
                              "perPage",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.onPerPageChange(_vm.serverParams.perPage)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "10" } }, [
                        _vm._v("10 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "20" } }, [
                        _vm._v("20 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "30" } }, [
                        _vm._v("30 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "40" } }, [
                        _vm._v("40 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "50" } }, [
                        _vm._v("50 / page")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "footer__row-count__label" }, [
                    _vm._v("of " + _vm._s(_vm.totalRecords) + " total records")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-12 col-md-6 text-right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn",
                      class: { disabled: parseInt(_vm.currentPage) - 1 <= 0 },
                      attrs: { href: "javascript:void(0)", tabindex: "0" },
                      on: {
                        click: function($event) {
                          _vm.onPrevChange(parseInt(_vm.currentPage))
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "chevron left" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Prev")])
                    ]
                  ),
                  _vm._v("\n            page\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentPage,
                        expression: "currentPage"
                      }
                    ],
                    staticStyle: { width: "100px" },
                    attrs: { min: "1", type: "number" },
                    domProps: { value: _vm.currentPage },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.onPageChange(parseInt(_vm.currentPage))
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentPage = $event.target.value
                      }
                    }
                  }),
                  _vm._v(
                    "\n            of " +
                      _vm._s(
                        Math.ceil(_vm.totalRecords / _vm.serverParams.perPage)
                      ) +
                      "\n            "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "footer__navigation__page-btn",
                      class:
                        "btn " +
                        {
                          disabled:
                            parseInt(_vm.currentPage) + 1 >
                            Math.ceil(
                              _vm.totalRecords / _vm.serverParams.perPage
                            )
                        },
                      attrs: { href: "javascript:void(0)", tabindex: "0" },
                      on: {
                        click: function($event) {
                          _vm.onNextChange(parseInt(_vm.currentPage))
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Next")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "chevron right" })
                    ]
                  )
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("form-data", { attrs: { searchData: _vm.searchData } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Description")]),
        _vm._v(" "),
        _c("th", [_vm._v("Whatsapp Number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Whatsapp Group Number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Actions")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn btn-white btn-sm btn-rounded dropdown-toggle",
        attrs: {
          href: "#",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [
        _c("i", { staticClass: "fa fa-dot-circle-o text-danger" }),
        _vm._v(
          "\n                            Options\n                          "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "text-center", attrs: { colspan: "4" } }, [
        _vm._v("-empty-")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53761558", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53761558","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/brands/list.vue
// module id = null
// module chunks = 